export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_03.b6554d09.mp4";